import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import routes from 'routes.js';

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route path={`${prop.path}`} element={prop.component} key={key} />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = 'ltr';

  return (
    <Routes>
      {getRoutes(routes)}
      <Route
        path="/"
        element={<Navigate to="/auth/sign-in/default" replace />}
      />
    </Routes>
  );
}
